import _ from "lodash";

/**
 * Получить полный адрес по договору
 *
 * @param {Object} address
 * @return {String}
 */
export default function getContractAddress(address) {
  if (_.isEmpty(address)) return null;

  return `${address.city}, ${address.street}, ${address.house}${
    address.flat ? `, ${address.flat}` : ""
  }`;
}
